import { SET_LOADING } from './types';

export const setLoading = (loading) => async (dispatch) => dispatch({ type: SET_LOADING, payload: loading });
